import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import LsDisplay from "../components/LsDisplay"
import Header from "../components/header"
import StatusBar from "../components/StatusBar"
import StatsPanel from "../components/StatsPanel"
import TechMarquee from "../components/TechMarquee"
import AboutSection from "../components/AboutSection"

const IndexPage: React.FC = () => (
  <>
    <Seo
      title="Ayemun Hossain — Senior Software Engineer · Backend · Cloud · AI · DevSecOps"
      description="Portfolio of Ayemun Hossain, Senior Software Engineer specialising in Node.js, NestJS, Django, Apache Kafka, gRPC, AWS, Azure, Kubernetes, and AI-native systems. 40+ open-source projects across backend, microservices, RAG, vector search, streaming, and DevSecOps."
      keywords="Ayemun Hossain, Ayemun Hossain portfolio, senior software engineer, backend engineer, AI engineer, DevSecOps, Node.js, NestJS, Django, Python, Apache Kafka, gRPC, microservices, RAG, vector search, Kubernetes, Docker, Terraform, AWS, Azure, cloud, distributed systems"
    />
    <Layout>
      <Header />
      <StatusBar />
      <StatsPanel />
      <TechMarquee />
      <div className="container">
        <LsDisplay />
      </div>
      <AboutSection />
    </Layout>
  </>
)

export default IndexPage
